export default "__VITE_ASSET__CN2ngcK4__"